module.exports = __webpack_public_path__ + "static/media/otp.e9bc9d51.svg";